<ng-container *transloco="let t; read: 'findMyAgent.property'">
  <label class="text-heading-2 text-steel-100 mb-6 block" id="property-label">{{ t('title') }}</label>
  @if (store.propertyTypes$ | async; as options) {
    <rma-group-select class="grid grid-cols-2 gap-4 md:grid-cols-4" [formControl]="control" aria-labelledby="property-label">
      @for (option of options | keyvalue; track option; let i = $index) {
        <rma-group-select-option
          #optionItem
          [option]="{ label: option.key, value: option.key }"
          [optionTemplate]="optionTemplate"
          [tabindex]="i + 1">
          <ng-template #optionTemplate>
            <div
              class="bg-blue-10 hover:text-blue-10 active:text-blue-10 flex flex-col items-center justify-center p-4 font-bold text-blue-100 hover:bg-blue-50 focus:border focus:border-blue-100 active:bg-blue-100"
              [class.bg-blue-100]="optionItem.selected"
              [class.text-blue-10]="optionItem.selected"
              [attr.data-id]="'property-type-' + option.key">
              <rma-icon [glyph]="option.value" />
              {{ 'property-types.' + option.key | transloco }}
            </div>
          </ng-template>
        </rma-group-select-option>
      }
    </rma-group-select>
  }
</ng-container>
